// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1OfJi","resendInfoText":"OnGoingPaymentBox_resendInfoText__1hAxp"};